/* In house cart drawer. Replaces Kaching Cart AND the California side cart.
   Shows automatic discounts per line, which is how the bundle pricing
   becomes visible to the customer.

   Shipping protection: an optional line item toggled from the drawer. It is
   kept OUT of the item list (it is not merchandise) and OUT of the free
   shipping maths (you should not be able to buy your way to free shipping with
   a protection fee).

   The theme's own drawer opens by putting `shopping` on <body>, which also dims
   the header overlay and locks scroll. This file takes over every route into
   the cart, in the CAPTURE phase so the theme's handler never runs, and adds
   `igc-ready` to <html> once it has initialised. ig-cart-extras.css hides the
   native drawer only while that class is present, so a failure here degrades
   back to the theme cart instead of leaving no cart at all. */
(function () {
  'use strict';

  var root, overlay, bodyEl, footEl, countEl, shipEl, protEl, upEl, cfg;
  var busy = false;
  var lastFocus = null;
  var protKey = null;
  var protSweep = false;
  var upIndex = 0;
  var upSel = {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function money(c) {
    return (cfg.symbol || '$') + (c / 100).toLocaleString('en-US',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function protId() {
    return cfg && cfg.protection && cfg.protection.id ? cfg.protection.id : null;
  }

  function itemHtml(it) {
    var allocs = it.line_level_discount_allocations || [];
    var names = allocs.map(function (d) {
      return '<span class="igc__tag">' + esc(d.discount_application.title) + '</span>';
    }).join(' ');

    var discounted = it.original_line_price > it.final_line_price;
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';

    return '' +
      '<div class="igc__item" data-key="' + esc(it.key) + '">' +
        (it.image
          ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" width="72" height="90" loading="lazy">'
          : '<span class="igc__ph"></span>') +
        '<div class="igc__info">' +
          '<span class="igc__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></span>' +
          (variant ? '<span class="igc__variant">' + esc(variant) + '</span>' : '') +
          (names ? '<span>' + names + '</span>' : '') +
          '<div class="igc__row">' +
            '<span class="igc__qty">' +
              '<button type="button" class="igc__qbtn" data-step="-1" aria-label="Reduce quantity">&minus;</button>' +
              '<span class="igc__qnum">' + it.quantity + '</span>' +
              '<button type="button" class="igc__qbtn" data-step="1" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<span class="igc__prices">' +
              (discounted ? '<span class="igc__was">' + money(it.original_line_price) + '</span>' : '') +
              '<span class="igc__now">' + money(it.final_line_price) + '</span>' +
            '</span>' +
          '</div>' +
          '<button type="button" class="igc__remove" data-remove>Remove</button>' +
        '</div>' +
      '</div>';
  }

  function protectHtml(on) {
    var p = cfg.protection;
    return '' +
      '<label class="igc__protect-row">' +
        '<svg class="igc__protect-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M12 2.5 4.5 5.6v5.3c0 4.6 3.2 8.9 7.5 10.1 4.3-1.2 7.5-5.5 7.5-10.1V5.6L12 2.5Z" fill="#1BA1E2"/>' +
          '<path d="m10.6 14.3-2.2-2.2 1.2-1.2 1 1 3.8-3.8 1.2 1.2-5 5Z" fill="#fff"/>' +
        '</svg>' +
        '<span class="igc__protect-text">' +
          '<span class="igc__protect-title">' + esc(p.title || 'Shipping Protection') + '</span>' +
          '<span class="igc__protect-blurb">' + esc(p.blurb || '') + '</span>' +
        '</span>' +
        '<span class="igc__protect-price">' + money(p.price) + '</span>' +
        '<input type="checkbox" class="igc__switch" data-igc-protect-toggle' + (on ? ' checked' : '') + '>' +
      '</label>';
  }


  /* ---- upsell carousel ---------------------------------------------------
     One card at a time, arrows to move. Products already in the cart are
     skipped. A save badge is shown ONLY when the variant carries a compare at
     price genuinely higher than its price, which Liquid has already filtered,
     so the badge can never be invented here. */

  function upList(cart) {
    var ups = (cfg && cfg.upsells) || [];
    if (!ups.length) return [];
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id] = 1; });
    return ups.filter(function (p) {
      var anyInCart = p.v.some(function (v) { return inCart[v.id]; });
      var anyBuyable = p.v.some(function (v) { return v.a; });
      return !anyInCart && anyBuyable;
    });
  }

  function upColours(p) {
    var seen = {}, out = [];
    p.v.forEach(function (v) {
      if (seen[v.c]) return;
      seen[v.c] = 1;
      out.push({ name: v.c, ok: p.v.some(function (x) { return x.c === v.c && x.a; }) });
    });
    return out;
  }
  function upSizes(p, colour) {
    var seen = {}, out = [];
    p.v.forEach(function (v) {
      if (v.c !== colour || seen[v.s]) return;
      seen[v.s] = 1;
      out.push({ name: v.s, ok: v.a });
    });
    return out;
  }
  function upVariant(p, colour, size) {
    for (var i = 0; i < p.v.length; i++) {
      if (p.v[i].c === colour && p.v[i].s === size) return p.v[i];
    }
    return null;
  }
  function upSeed(p) {
    for (var i = 0; i < p.v.length; i++) {
      if (p.v[i].a) return { c: p.v[i].c, s: p.v[i].s };
    }
    return { c: p.v[0].c, s: p.v[0].s };
  }

  function upCardHtml(p, many) {
    if (!upSel[p.h]) upSel[p.h] = upSeed(p);
    var sel = upSel[p.h];
    var v = upVariant(p, sel.c, sel.s);
    var price = v ? v.p : p.v[0].p;
    var was = v && v.was ? v.was : null;
    var pct = was ? Math.round((1 - price / was) * 100) : 0;

    return '' +
      '<div class="igc__up-head">' +
        '<span class="igc__up-eyebrow">Finish the kit</span>' +
        (many
          ? '<span class="igc__up-nav">' +
              '<button type="button" class="igc__up-arrow" data-up-move="-1" aria-label="Previous suggestion">&lsaquo;</button>' +
              '<button type="button" class="igc__up-arrow" data-up-move="1" aria-label="Next suggestion">&rsaquo;</button>' +
            '</span>'
          : '') +
      '</div>' +
      '<div class="igc__up-card">' +
        (p.img ? '<img class="igc__up-img" src="' + esc(p.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="igc__up-img"></span>') +
        '<div class="igc__up-info">' +
          '<a class="igc__up-title" href="' + esc(p.url) + '">' + esc(p.t) + '</a>' +
          '<span class="igc__up-price">' +
            '<strong>' + money(price) + '</strong>' +
            (was ? ' <s>' + money(was) + '</s>' : '') +
            (pct > 0 ? ' <em class="igc__up-save">You save ' + pct + '%</em>' : '') +
          '</span>' +
          '<span class="igc__up-selects">' +
            '<select data-up-colour aria-label="Colour">' +
              upColours(p).map(function (c) {
                return '<option value="' + esc(c.name) + '"' + (c.name === sel.c ? ' selected' : '') + (c.ok ? '' : ' disabled') + '>' + esc(c.name) + '</option>';
              }).join('') +
            '</select>' +
            '<select data-up-size aria-label="Size">' +
              upSizes(p, sel.c).map(function (z) {
                return '<option value="' + esc(z.name) + '"' + (z.name === sel.s ? ' selected' : '') + (z.ok ? '' : ' disabled') + '>' + esc(z.name) + (z.ok ? '' : ' (sold out)') + '</option>';
              }).join('') +
            '</select>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="igc__up-add" data-up-add' + (v && v.a ? '' : ' disabled') + '>' +
          (v && v.a ? 'Add to cart' : 'Sold out') +
        '</button>' +
      '</div>';
  }

  function renderUpsell(cart) {
    if (!upEl) return;
    var list = upList(cart);
    if (!list.length) { upEl.hidden = true; upEl.innerHTML = ''; return; }
    if (upIndex >= list.length) upIndex = 0;
    if (upIndex < 0) upIndex = list.length - 1;
    upEl.hidden = false;
    upEl.setAttribute('data-up-handle', list[upIndex].h);
    upEl.innerHTML = upCardHtml(list[upIndex], list.length > 1);
  }

  function addVariant(id) {
    if (busy || !id) return;
    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .catch(function () {})
      .then(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  function render(cart) {
    var pid = protId();
    var items = [];
    var protLine = null;
    var merchCount = 0;

    cart.items.forEach(function (it) {
      if (pid && it.variant_id === pid) { protLine = it; return; }
      items.push(it);
      merchCount += it.quantity;
    });
    protKey = protLine ? protLine.key : null;

    /* Protection left behind after the last real item was removed. Drop it once;
       the resulting refresh lands on the genuine empty state. */
    if (!items.length && protLine && !protSweep) {
      protSweep = true;
      change(protLine.key, 0);
      return;
    }
    if (items.length) protSweep = false;

    countEl.textContent = merchCount === 1 ? '1 item' : merchCount + ' items';

    if (!items.length) {
      bodyEl.innerHTML =
        '<div class="igc__empty"><p>Your cart is empty.</p>' +
        '<a class="btn action" href="' + esc(cfg.emptyUrl || '/collections/all') + '">' +
        esc(cfg.emptyCta || 'Start shopping') + '</a></div>';
      footEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      if (protEl) protEl.hidden = true;
      if (upEl) { upEl.hidden = true; upEl.innerHTML = ''; }
      return;
    }

    footEl.hidden = false;
    bodyEl.innerHTML = items.map(itemHtml).join('');

    /* Merchandise only: the protection fee must not count toward free shipping. */
    var merchTotal = cart.total_price - (protLine ? protLine.final_line_price : 0);

    if (shipEl && cfg.freeShipping > 0) {
      shipEl.hidden = false;
      var left = cfg.freeShipping - merchTotal;
      var pct = Math.max(0, Math.min(100, (merchTotal / cfg.freeShipping) * 100));
      shipEl.innerHTML =
        '<p class="igc__ship-msg">' +
          (left > 0
            ? 'You are ' + money(left) + ' away from free shipping.'
            : '<strong>Free shipping unlocked.</strong>') +
        '</p><div class="igc__bar"><span style="width:' + pct + '%"></span></div>';
    } else if (shipEl) {
      shipEl.hidden = true;
    }

    renderUpsell(cart);

    if (protEl) {
      if (cfg.protection && cfg.protection.id) {
        protEl.hidden = false;
        protEl.innerHTML = protectHtml(!!protLine);
      } else {
        protEl.hidden = true;
      }
    }

    var saved = cart.total_discount || 0;
    footEl.innerHTML =
      (saved > 0
        ? '<div class="igc__line"><span>Original</span><span>' + money(cart.original_total_price) + '</span></div>' +
          '<div class="igc__line is-save"><span>You save</span><span>&minus;' + money(saved) + '</span></div>'
        : '') +
      (protLine
        ? '<div class="igc__line"><span>Shipping protection</span><span>' + money(protLine.final_line_price) + '</span></div>'
        : '') +
      '<div class="igc__line is-total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<button type="button" class="btn action full igc__cta" data-checkout>Checkout</button>' +
      '<button type="button" class="igc__second" data-close>Continue shopping</button>' +
      '<p class="igc__note">' + esc(cfg.note || '') + '</p>';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetchCart().then(function (c) { render(c); return c; });
  }

  function setBusy(on) {
    busy = on;
    root.classList.toggle('is-busy', on);
  }

  function change(key, qty) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  function addProtection() {
    var pid = protId();
    if (busy || !pid) return;
    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: pid, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .catch(function () {})
      .then(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  /* The theme shows its own drawer off body.shopping. Strip it whenever we take
     over, so it can never sit behind ours or leave its dim overlay. */
  function dropThemeCart() {
    document.body.classList.remove('shopping');
  }

  function open() {
    lastFocus = document.activeElement;
    dropThemeCart();
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = $('.igc__close', root);
    if (c) c.focus();
  }
  function close() {
    dropThemeCart();
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init() {
    root = $('[data-ig-cart]');
    if (!root) return;
    overlay = $('[data-ig-cart-overlay]');
    bodyEl = $('[data-igc-body]', root);
    footEl = $('[data-igc-foot]', root);
    countEl = $('[data-igc-count]', root);
    shipEl = $('[data-igc-ship]', root);
    protEl = $('[data-igc-protect]', root);
    upEl = $('[data-igc-upsell]', root);
    try { cfg = JSON.parse($('[data-igc-config]', root).textContent); }
    catch (e) { cfg = {}; }

    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.hasAttribute || !t.hasAttribute('data-igc-protect-toggle')) return;
      if (busy) { t.checked = !t.checked; return; }
      if (t.checked) addProtection();
      else if (protKey) change(protKey, 0);
    });

    /* upsell colour and size selects */
    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.hasAttribute) return;
      var isC = t.hasAttribute('data-up-colour');
      var isS = t.hasAttribute('data-up-size');
      if (!isC && !isS) return;
      var h = upEl && upEl.getAttribute('data-up-handle');
      var p = (cfg.upsells || []).filter(function (x) { return x.h === h; })[0];
      if (!p) return;
      if (!upSel[h]) upSel[h] = upSeed(p);
      if (isC) {
        upSel[h].c = t.value;
        var ok = upSizes(p, t.value).filter(function (z) { return z.ok; });
        var keep = ok.filter(function (z) { return z.name === upSel[h].s; })[0];
        upSel[h].s = (keep || ok[0] || upSizes(p, t.value)[0] || {}).name;
      } else {
        upSel[h].s = t.value;
      }
      upEl.innerHTML = upCardHtml(p, ((cfg.upsells || []).length > 1));
    });

    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.closest('[data-igc-protect]')) return;

      var mv = t.closest('[data-up-move]');
      if (mv) { upIndex += parseInt(mv.getAttribute('data-up-move'), 10); refresh(); return; }
      if (t.closest('[data-up-add]')) {
        var h2 = upEl && upEl.getAttribute('data-up-handle');
        var p2 = (cfg.upsells || []).filter(function (x) { return x.h === h2; })[0];
        if (!p2) return;
        var sel2 = upSel[h2] || upSeed(p2);
        var v2 = upVariant(p2, sel2.c, sel2.s);
        if (v2 && v2.a) addVariant(v2.id);
        return;
      }
      if (t.closest('[data-igc-upsell]')) return;
      if (t.closest('[data-close]') || t.classList.contains('igc__close')) { close(); return; }
      if (t.closest('[data-checkout]')) { window.location.href = '/checkout'; return; }

      var item = t.closest('[data-key]');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var qnum = $('.igc__qnum', item);
      var current = parseInt(qnum ? qnum.textContent : '1', 10) || 1;

      if (t.closest('[data-remove]')) { change(key, 0); return; }
      var step = t.getAttribute && t.getAttribute('data-step');
      if (step) change(key, Math.max(0, current + parseInt(step, 10)));
    });

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* Own every route into the cart. CAPTURE phase plus stopPropagation so the
       theme's own delegated handler never runs and never sets body.shopping,
       which is what used to open the native side cart behind this one. The
       igc-ready guard keeps this inert if init never completed. */
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest(
        'a[href$="/cart"], a[href*="/cart?"], [data-action="toggle-cart"]');
      if (!a) return;
      if (!document.documentElement.classList.contains('igc-ready')) return;
      if (root.contains(a)) return;
      ev.preventDefault();
      ev.stopPropagation();
      refresh().then(open);
    }, true);

    var nativeFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update)(\.js)?/.test(href)) {
        p.then(function (res) {
          if (res && res.ok) {
            refresh().then(function () {
              if (/\/cart\/add/.test(href)) open();
            });
          }
        }).catch(function () {});
      }
      return p;
    };

    window.IGCart = { open: function () { return refresh().then(open); }, close: close, refresh: refresh };

    document.documentElement.classList.add('igc-ready');
    refresh();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
